import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faCheck,
  faDownload,
  faHome,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { getProductionList } from "../../Service/AllProductionAPI";
import swal from "sweetalert";

export default (props) => {
  const [selectedRowData, setSelectedRowData] = useState([]);
 const [entries, setEntries] = useState([]);
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      console.log("row",row);
      console.log("isSelect",isSelect);
      console.log("rowIndex",rowIndex);
      if (isSelect) {
        setSelectedRowData([...selectedRowData, row]);
        console.log(selectedRowData);
      } else {
        setSelectedRowData(selectedRowData.filter((v) => v !== row));
        console.log("selectedRowData",selectedRowData);
      }
    },
    onSelectAll: (isSelect, rows, e) => {
      console.log("row",rows);
      console.log("isSelect",isSelect);
      if (isSelect) {
        setSelectedRowData(rows);
        console.log(selectedRowData);
      } else {
        setSelectedRowData([]);
        console.log(selectedRowData);
      }
    },
  };

  useEffect(() => {
    onRowSelection();
  }, [selectedRowData]);

  const onRowSelection = () => {
    console.log("onRowSelection selectedRowData.length :-", selectedRowData.length);
    try {
      if (selectedRowData.length !== 0) {
        props.sendFromDispatchGrid(selectedRowData);
      }
      else {
        props.sendFromDispatchGrid([]);
      }
      console.log("our Row Data", selectedRowData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
   // getProduction(); // Function call to get Production list
  }, []);

  // const getProduction = async () => {
  //   try {
  //     const token = sessionStorage.getItem("token");
  //     const headers= {"Authorization" : `Bearer ${token}`}
  //     await getProductionList(headers)
  //       .then((result) => {
  //         console.log("Get Production Result", result);
  //         if (result?.data?.length !== 0) {
  //           setEntries(result.data);
  //         } else {
  //           swal("Sorry", "Data is not present", "warning");
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("Get Production Error", error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //     swal(
  //       "Failed",
  //       "Something went wrong please check your internet",
  //       "error"
  //     );
  //   }
  // };
 // Adding srno column to list
//  const entries = [
//   { id: 1, srno: "1", dispensertype: "1111" },
//   { id: 2, srno: "2", dispensertype: "1121" },
//   { id: 3, srno: "3", dispensertype: "1222" },
//   { id: 4, srno: "4", dispensertype: "2222" },
// ];


  const customTotal = (from, to, size) => (
    <div>
      Showing {from} to {to} of {size} entries
    </div>
  );

  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };
  return (
    <>
      <hr />
      <br />
      <ToolkitProvider
        keyField="id"
        // search={true}
        columns={props.columns}
       // data={entries}
        data={props.entries}
        exportCSV
      >
        {({ baseProps, searchProps, csvProps }) => (
          <Paginator.PaginationProvider
            pagination={Pagination({
              custom: true,
              showTotal: true,
              alwaysShowAllBtns: true,
              totalSize: props.entries.length,
              paginationTotalRenderer: customTotal,
              sizePerPageRenderer: customSizePerPage,
            })}
          >
            {({ paginationProps, paginationTableProps }) => (
              <Card>
                <div className="table-responsive py-2">
                  {/* <Card.Header>
                    <Row> */}
                      {/* <Col xs={12} md={6} className="py-1">
                        <Paginator.SizePerPageDropdownStandalone
                          {...paginationProps}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={6}
                        className="d-flex justify-content-md-end py-1"
                      > */}
                        {/* <Search.SearchBar {...searchProps} /> */}
                        {/* <ExportCSVButton {...csvProps}>
                          <FontAwesomeIcon icon={faDownload} className="me-2" />
                        </ExportCSVButton> */}
                      {/* </Col> */}
                    {/* </Row>
                  </Card.Header> */}

                  <Table
                    {...baseProps}
                    {...paginationTableProps}
                    bodyClasses="border-0"
                    rowClasses="border-bottom"
                    classes="table-flush dataTable-table"
                    selectRow={selectRow}
                    cellEdit={cellEditFactory({ mode: "click" })}
                    wrapperClasses="table-responsive"
                  />
                  <Card.Footer>
                    <Row>
                      <Col
                        xs={12}
                        md={6}
                        className="d-flex align-items-center py-1"
                      >
                          {/* <Paginator.PaginationTotalStandalone
                          {...paginationProps}
                        /> */}
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                      >
                        <Paginator.PaginationListStandalone
                          {...paginationProps}
                        />
                      </Col>
                    </Row>
                  </Card.Footer>
                </div>
              </Card>
            )}
          </Paginator.PaginationProvider>
        )}
      </ToolkitProvider>
    </>
  );
};
